import { Carousel as MantineCarousel } from '@mantine/carousel';

export const Carousel = MantineCarousel.extend({
	defaultProps: {
		withControls: false,
		slideGap: 2,
		slideSize: 'min-content',
		emblaOptions: {
			dragFree: true,
			align: 'start',
		},
	},
});
